import { styled } from '@slal/ui';
export const Div = styled.div``;

export const FlexDiv = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
`;
